import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Loading from '../../../assets/loading.gif';
import 'jquery-ui-dist/jquery-ui';
import { callStarpagoApi, getDeposit } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import 'jquery-ui-dist/jquery-ui';



const StarPago = (props) => {

    const { translate, lang } = useLanguage();
    const [loadingStarpagoInfo, setLoadingStarpagoInfo] = useState(false);
    const [infoStarpago, setInfoStarpago] = useState(sessionStorage.getItem("starpago_info") !== null ? JSON.parse(sessionStorage.getItem("starpago_info")) : {});
    const [waitingPayment, setWaitingPayment] = useState(sessionStorage.getItem("waiting_payment") !== null ? JSON.parse(sessionStorage.getItem("waiting_payment")) : false);
    const [isError, setIsError] = useState(false)
    const [erorMsg, setErrorMsg] = useState("")

    useEffect(() => {
        translate();
    }, [translate]);

    const callStarpago = () => {
        setLoadingStarpagoInfo(true);
        if (infoStarpago[props.payment_type] === undefined) {
            callStarpagoApi(sessionStorage.getItem("order_no"), props.payment_type)
                .then(res => {
                    if (res !== undefined) {
                        setInfoStarpago({ ...infoStarpago, [props.payment_type]: res });
                        sessionStorage.setItem("starpago_info", JSON.stringify({ ...infoStarpago, [props.payment_type]: res }));
                        setLoadingStarpagoInfo(false)
                    } else {
                        setErrorMsg("Please, talk with the Administrator.");
                        setLoadingStarpagoInfo(false);
                        setIsError(true)
                    }
                })
                .catch(err => {
                    console.log(err.toString());
                    setErrorMsg(err.response?.data?.message ? err.response?.data?.message : "Internal server error")
                    setIsError(true)
                }).finally(() => {
                    setLoadingStarpagoInfo(false);
                    translate();
                });
        }

    }

    useEffect(() => {
        let timeout;
        function checkPayment() {
            timeout = setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            sessionStorage.setItem("waiting_payment", false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    })
            }, 30000);
        }
        if (waitingPayment) {
            sessionStorage.setItem("waiting_payment", true);
            checkPayment();
        }
        return () => clearTimeout(timeout);
    }, [loadingStarpagoInfo]);


    useEffect(() => {
        if (infoStarpago[props.payment_type] === undefined) {
            callStarpago()
        }
        return () => {
            const iframe = document.getElementById('monnet_frame');
            if (iframe) {
                iframe.removeEventListener('load',()=>{})
            }
        }
    }, [])
    const [loading, setLoading] = useState(true);

    const handleLoad = () => {
        setLoading(false);
    };

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.type === 'redirected') {
                const redirectedUrl = event.data.url;
                window.location.href=redirectedUrl
            }
        }
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);


    return (
        <>
            {loadingStarpagoInfo && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}

            <div className=''>
                {infoStarpago[props.payment_type] !== undefined ?
                    <>
                        <div style={{ width: '100%' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                {loading && <div className="loader"> <img src={Loading} alt={"loading"} width="30px" height="30px" /></div>}
                            </div>

                            <iframe
                                id='monnet_frame'
                                src={`${infoStarpago[props.payment_type]['params']['url']}`}
                                title={`${props.payment_type}`}
                                width="100%"
                                height="800px"
                                onLoad={handleLoad}
                                style={{ display: loading ? 'none' : 'block' }}
                            />
                        </div>
                    </>
                    :
                    <>
                    </>
                }

                {isError && <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                    <h4>{erorMsg}</h4>
                </div>}
            </div>

        </>
    )
}

export default StarPago;